import { AppShell } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./TaxClientHome.scss";
import { useEffect, useState } from "react";
import MainHeader from "../../components/Tax Client Only/MainHeader/MainHeader";
import { getTaxProInfo } from "../../utils/api";
import MobileButtons from "../../components/Tax Client Only/MobileButtons/MobileButtons";
import HomeHeader from "../../components/HomeHeader/HomeHeader";
import ClientNextStep from "./Panels/ClientNextStep/ClientNextStep";
import ClientPayment from "./Panels/ClientPayment/ClientPayment";
import ClientConsult from "./Panels/ClientConsult/ClientConsult";
import ClientPaymentRequests from "../Payments/ClientPaymentRequests/ClientPaymentRequests";

const TaxClientHome = () => {
  // Sidebar toggle
  const [opened, { toggle }] = useDisclosure(false);

  const personalInfoString = localStorage.getItem("personalInfo");
  const personalInfo = personalInfoString ? JSON.parse(personalInfoString) : {};

  const [taxpro, setTaxpro] = useState<any>({});

  const getPersonalData = async () => {
    const response = await getTaxProInfo();
    setTaxpro(response?.data?.content);
  };

  useEffect(() => {
    getPersonalData();
  }, []);

  // Determine the presence of payment and consult links
  const hasPayment = Boolean(taxpro?.paymentLink);
  const hasConsult = Boolean(taxpro?.consultLink);

  return (
    <AppShell
      className="client-page"
      header={{ height: 87 }}
      navbar={{
        width: "15.375rem",
        breakpoint: "sm",
        collapsed: { mobile: !opened },
      }}
      padding="md"
    >
      <AppShell.Header className="app-header">
        <MainHeader opened={opened} toggle={toggle} />
      </AppShell.Header>
      <AppShell.Navbar className="nav">
        <Sidebar />
      </AppShell.Navbar>
      <AppShell.Main className="main">
        <div className="main-content-client">
          <div className="home-header">
            <HomeHeader firstName={personalInfo?.firstName} isClient />
          </div>

          <div className="client-next-step">
            <ClientNextStep clientStatus={personalInfo?.status} />
          </div>

          <div className="client-payment-requests">
            <ClientPaymentRequests />
          </div>
          {hasPayment && (
            <div
              className={`client-payment ${!hasConsult ? "full-width" : ""}`}
            >
              <ClientPayment paymentLink={taxpro.paymentLink} />
            </div>
          )}

          {hasConsult && (
            <div
              className={`client-consult ${!hasPayment ? "full-width" : ""}`}
            >
              <ClientConsult consultLink={taxpro.consultLink} />
            </div>
          )}

          <MobileButtons />
        </div>
      </AppShell.Main>
    </AppShell>
  );
};

export default TaxClientHome;
